export function normalizeZambiaPhone(input) {
  const raw = String(input || '').trim();
  if (!raw) return '';

  // If user typed an email, keep it unchanged
  if (raw.includes('@')) return raw;

  const digits = raw.replace(/[^\d+]/g, '');
  if (digits.startsWith('+')) {
    return `+${digits.replace(/[^\d]/g, '')}`;
  }

  const onlyDigits = raw.replace(/[^\d]/g, '');
  if (!onlyDigits) return '';

  // Common local formats:
  // 0971234567 -> +260971234567
  // 971234567  -> +260971234567
  // 260971...  -> +260971...
  if (onlyDigits.startsWith('260')) return `+${onlyDigits}`;
  if (onlyDigits.startsWith('0')) return `+260${onlyDigits.slice(1)}`;
  return `+260${onlyDigits}`;
}

